/* Capture specific album pricing rule */
const AlbumScanningPrice = {
	// Captures charges $29.99 for first 35 photos scanned + $0.70 per photo after the first 35, per album, up to 5 albums per order.
	rule: function (price, photoQuantityArr, albumQuantity, isSale) {
		const upsellTotal =
			Number($(".product-price").attr("data-upsell-dvd-total-price")) +
			Number($(".product-price").attr("data-upsell-usb-total-price"));
    var extraItemPrice = Number($(".product-price").attr("data-extra-price"));
    const includedQuantity = Number($(".product-price").attr("data-included-quantity"));
		var extraCharge = extraItemPrice;

    var newPrice = 0;

		for (let i = 0; i < albumQuantity; i++) {
      var photoQuantity = photoQuantityArr[i];
      var extraQuantity = photoQuantity - includedQuantity;

      newPrice += price;
      if (extraQuantity > 0) {
        // add any extra quantity
        newPrice += extraCharge * extraQuantity;
      }
		}
		newPrice += upsellTotal;
		return [newPrice, formatMoney(newPrice)];
	},
	variants: function (callback) {
		var albumQuantityInputs = $('input[name="album-quantity"]');
		var albumQuantityPriceTotalWrapper = $(
			".product-price-quantity .album-quantity .label-quantity"
		);
		var albumQuantityPricePhotoWrapper = $(
			".product-price-quantity .photo-quantity .label-quantity"
		);
		var submitButton = $("button.product-form__submit");

		albumQuantityInputs.change(function (e) {
			var value = Number($(this).val());
			var errorMessageWrapper = $(
				".product-album__error-message-wrapper"
			);
			if (value > CONSTANTS.ALBUM.MAX_INPUT) {
				$(this).val(CONSTANTS.ALBUM.MAX_INPUT);
				errorMessageWrapper.removeAttr("hidden");
				errorMessageWrapper
					.find(".product-album__error-message")
					.text(
						`Maximum quantity for album input is ${CONSTANTS.ALBUM.MAX_INPUT}`
					);
			} else {
				errorMessageWrapper.attr("hidden", true);
			}

			var albumQuantity = 0;
			var albumPhotoTotal = 0;
			var albumPhotoTotalArray = [];
			// Update total number of photos input
			albumQuantityInputs.each(function (i, e) {
				var value = Number($(this).val());
				if (value) {
					albumPhotoTotal += value;
					albumPhotoTotalArray[i] = value;
				}
			});
			// Update total number of albums selected
			var albumQuantity = albumQuantityInputs.filter(function () {
				var value = Number($(this).val());
				return value;
			}).length;

			albumQuantityPriceTotalWrapper.text(albumQuantity);

			albumQuantityPricePhotoWrapper.text(albumPhotoTotal);

			if (albumQuantity > 0) {
				if (submitButton.prop("disabled")) {
					submitButton.prop("disabled", false);
				}
			} else {
				submitButton.prop("disabled", true);
			}
			// Callback
			if (callback) {
				callback(albumQuantity, albumPhotoTotalArray.filter(Boolean));
			}
		});
	},

  dynamicPrice: function() {

     const extraItemPrice          = Number($(".product-price").attr("data-extra-price"));
     const extraItemCompareAtPrice = Number($(".product-price").attr("data-extra-compare-at-price"));
     const includedQuantity        = Number($(".product-price").attr("data-included-quantity"));
     const productPrice            = Number($(".product-price").attr("data-price"));
     const productCompareAtPrice   = Number($(".product-price").attr("data-compare-price"));

     if (extraItemPrice) {
       $(".unit-item-extra-item-price").text( formatMoney(extraItemPrice) );
     }

     if (extraItemCompareAtPrice) {
       $(".unit-item-extra-item-compare-at-price").text( formatMoney(extraItemCompareAtPrice) );
     }

     if (productPrice) {
       $(".unit-item-price").text( formatMoney(productPrice) );
     }

     if (productCompareAtPrice) {
       $(".unit-item-compare-at-price").text( formatMoney(productCompareAtPrice) );
     }

     if (includedQuantity) {
       $(".unit-item-included-quantity").text( includedQuantity );
     }

   },

};

document.addEventListener("DOMContentLoaded", () => {
	const priceRegularWrapper = $(".product-price .price-item--regular");
	const priceSaleWrapper = $(".product-price .price-item--sale");
	const originalPrice = Number(
		$(".product-price").attr("data-compare-price")
	);
	const originalSalePrice = Number($(".product-price").attr("data-price"));

  AlbumScanningPrice.dynamicPrice();

	AlbumScanningPrice.variants((albumQuantity, albumPhotoTotalArray) => {
		const [newPriceRegular, newPriceRegularFormatted] =
			AlbumScanningPrice.rule(
				originalPrice,
				albumPhotoTotalArray,
				albumQuantity
			);
		const [newPriceSale, newPriceSaleFormatted] = AlbumScanningPrice.rule(
			originalSalePrice,
			albumPhotoTotalArray,
			albumQuantity,
			true
		);
		priceRegularWrapper.text(newPriceRegularFormatted);
		priceSaleWrapper.text(newPriceSaleFormatted);
		$(".product-price").attr("data-total-price", newPriceSale);
		$(".product-price").attr("data-total-compare-price", newPriceRegular);
	});
});